import {lazy, Suspense} from 'react';
import {Navigate, Route, Routes} from 'react-router-dom';

import ClickSpark from '@/components/effects/ClickSpark';

const Portfolio = lazy(() => import('@/modules/Portfolio'));

export default function App() {
    return (
        <ClickSpark sparkColor="#fff" sparkSize={10} sparkRadius={15} sparkCount={8} duration={400}>
            <Suspense fallback={null}>
                <Routes>
                    <Route path="/" element={<Portfolio />} />
                    <Route path="*" element={<Navigate replace to="/" />} />
                </Routes>
            </Suspense>
        </ClickSpark>
    );
}
